export default {
    day: '2023-10-16',
    content: {
        meta: [
            {
                type: 'appearance',
                text: '137'
            }
        ],
        mining: [
            {
                unlock: 'miningPickaxeCrafting',
                type: 'clarity',
                text: '141'
            }
        ],
        village: [
            {
                unlock: 'achievementFeature',
                type: 'bugfix',
                text: '148'
            }
        ],
        achievement: [
            {
                unlock: 'relicFeature',
                type: 'qol',
                text: '154'
            }
        ],
        horde: [
            {
                unlock: 'hordeEquipment',
                type: 'qol',
                text: '110'
            },
            {
                unlock: 'hordePrestige',
                type: 'qol',
                text: '111'
            },
            {
                unlock: 'hordePrestige',
                type: 'clarity',
                text: '134'
            },
            {
                type: 'appearance',
                text: '112'
            },
            {
                type: 'change',
                text: '118'
            },
            {
                type: 'bugfix',
                text: '119'
            },
            {
                unlock: 'hordeEquipment',
                type: 'qol',
                text: '121'
            },
            {
                type: 'accessibility',
                text: '133',
            },
            {
                unlock: 'hordeEquipment',
                type: 'new',
                text: 'addedHordeEquipment',
                params: [16]
            },
            {
                unlock: 'hordePrestige',
                type: 'new',
                text: 'addedHordeSigil',
                params: [24]
            },
            {
                unlock: 'hordeHeirlooms',
                type: 'new',
                text: 'addedHordeHeirloom',
                params: [5]
            },
            {
                unlock: 'hordeBrickTower',
                type: 'new',
                text: '135'
            },
            {
                type: 'info',
                text: '155'
            },
            {
                type: 'new',
                text: '113'
            },
            {
                type: 'balance',
                text: '142',
                balance: 'buff',
                before: '30',
                after: '90',
            },
            {
                type: 'balance',
                text: '143',
                balance: 'nerf',
                before: 'x2.5',
                after: 'x1.6',
            },
            {
                type: 'balance',
                text: '205',
                balance: 'buff',
                before: '10.00K',
                after: '500.0K'
            },
            {
                type: 'remove',
                text: '144'
            },
            {
                unlock: 'hordeDamageTypes',
                type: 'change',
                text: '114'
            },
            {
                unlock: 'hordePrestige',
                type: 'new',
                text: '115'
            },
            {
                unlock: 'hordePrestige',
                type: 'change',
                text: '116'
            },
            {
                type: 'change',
                text: '145'
            },
            {
                unlock: 'hordePrestige',
                type: 'remove',
                text: '117'
            },
            {
                unlock: 'hordePrestige',
                type: 'remove',
                text: '120'
            },
            {
                unlock: 'hordePrestige',
                type: 'new',
                text: '138'
            },
            {
                unlock: 'hordeHeirlooms',
                type: 'balance',
                text: '86',
                balance: 'nerf',
                before: '5%',
                after: '1%',
            },
            {
                unlock: 'hordeHeirlooms',
                type: 'balance',
                text: '87',
                balance: 'buff',
                before: '-0.1%',
                after: '+0.1%',
            },
            {
                unlock: 'hordePrestige',
                type: 'new',
                text: '122'
            },
            {
                unlock: 'hordeEquipment',
                type: 'change',
                text: '123'
            },
            {
                unlock: 'hordeEquipment',
                type: 'new',
                text: '124'
            },
            {
                unlock: 'hordeEquipment',
                type: 'new',
                text: '125'
            },
            {
                unlock: 'hordePrestige',
                type: 'new',
                text: '126'
            },
            {
                type: 'clarity',
                text: '127'
            },
            {
                type: 'balance',
                text: '128',
                balance: 'nerf',
                before: '+1',
                after: '+2',
            },
            {
                unlock: 'hordePrestige',
                type: 'new',
                text: '129'
            },
            {
                type: 'new',
                text: '130'
            },
            {
                type: 'new',
                text: '131'
            },
            {
                unlock: 'hordeHeirlooms',
                type: 'balance',
                text: '132'
            },
            {
                unlock: 'hordeHeirlooms',
                type: 'change',
                text: '136'
            },
            {
                type: 'change',
                text: '139'
            },
            {
                unlock: 'hordeBrickTower',
                type: 'new',
                text: '140'
            },
            {
                type: 'new',
                text: '146'
            },
            {
                type: 'new',
                text: '147'
            },
            {
                unlock: 'cardFeature',
                type: 'change',
                text: '149'
            },
            {
                unlock: 'hordeEquipment',
                type: 'change',
                text: '153'
            },
            {
                type: 'balance',
                text: '156'
            }
        ],
        general: [
            {
                type: 'accessibility',
                text: '109'
            }
        ],
        cryolab: [
            {
                type: 'change',
                text: '150'
            },
            {
                type: 'clarity',
                text: '151'
            }
        ],
        event: [
            {
                unlock: 'nightHuntEvent',
                type: 'qol',
                text: '152'
            }
        ],
    }
}
